import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=5416201e&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=5416201e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416201e",
  null
  
)

export default component.exports